var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("header",[_c('layout-header')]),_vm._v(" "),_c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"wrapper"},[_vm._t("default")],2)]),_vm._v(" "),_vm._t("footer",[_c('layout-footer')])],2)}
var staticRenderFns = []

export { render, staticRenderFns }